<glxy-alert *ngIf="requiredApps?.length > 0 && (showProductRequirementBanner$ | async)" type="info">
  <ng-container *ngIf="message$ | async as message; else loadingStencil">
    {{ message }}
  </ng-container>
</glxy-alert>

<ng-template #loadingStencil>
  <div class="loading stencil-shimmer"></div>
</ng-template>
